import { ChatStore } from '@/features/chat/store'
import { AuthStore } from '../features/auth/store'
import { ToolsStore } from '../features/tools/toolsStore'
import { ToolStore } from '@/features/tools/toolStore'
import { OrganizationsStore } from '@/features/organizations/store'
import { KnowledgeBaseStore } from '@/features/knowledge-bases/store'
import { KeyBindingsStore } from '@/features/keybindings/store'
import { ImpersonationStore } from '@/features/impersonation/store'
import { DepartmentsStore } from '@/features/departments/store'
import { SpacesStore } from '@/features/spaces/store'
import { NoveltyFeedbackStore } from '@/features/novelty-feedback/store'
import { VoiceChatStore } from '@/features/voice-chat/store'
import { ImageToolStore } from '@/features/image-tools/store'
import { SupportStore } from '@/features/support/store'
import { ArtifactStore } from '@/features/artifacts/store'

const rootStore: RootStore = {} as RootStore

export type RootStore = {
  tools: ToolsStore
  auth: AuthStore
  chat: ChatStore
  artifacts: ArtifactStore
  tool: ToolStore
  organizations: OrganizationsStore
  knowledgeBases: KnowledgeBaseStore
  keybindings: KeyBindingsStore
  impersonation: ImpersonationStore
  departments: DepartmentsStore
  spaces: SpacesStore
  noveltyFeedback: NoveltyFeedbackStore
  voiceChat: VoiceChatStore
  imageTool: ImageToolStore
  support: SupportStore
}

export interface Store {
  rootStore: RootStore
}

rootStore.tools = new ToolsStore(rootStore)
rootStore.auth = new AuthStore(rootStore)
rootStore.artifacts = new ArtifactStore(rootStore)
rootStore.chat = new ChatStore(rootStore)
rootStore.tool = new ToolStore(rootStore)
rootStore.organizations = new OrganizationsStore(rootStore)
rootStore.knowledgeBases = new KnowledgeBaseStore(rootStore)
rootStore.keybindings = new KeyBindingsStore(rootStore)
rootStore.impersonation = new ImpersonationStore(rootStore)
rootStore.departments = new DepartmentsStore(rootStore)
rootStore.spaces = new SpacesStore(rootStore)
rootStore.noveltyFeedback = new NoveltyFeedbackStore(rootStore)
rootStore.voiceChat = new VoiceChatStore(rootStore)
rootStore.imageTool = new ImageToolStore(rootStore)
rootStore.support = new SupportStore(rootStore)

export default rootStore
